exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.textfield[data-v-69eeda08]{\n\tmargin:16px;\n\tfont-size:24px;\n}\n.title[data-v-69eeda08] {\n\tmargin:16px;\n    margin-bottom:0px;\n\tfont-size:24px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69eeda08","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/edit/Edit_Box_Items.vue
// module id = 724
// module chunks = 0